<div class="relative block w-[34px]" [class]="{ 'hidden': !showElement() }">

    <app-button
        #hyperlinkBtn
        [type]="type"
        [active]="active()"
        [class]="'absolute right-0'"
        [custom]="['pill flex']"
        (click)="copyLink()"
    >
        
            <svg  xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor" class="size-4">
                <path stroke-linecap="round" stroke-linejoin="round" d="M13.19 8.688a4.5 4.5 0 0 1 1.242 7.244l-4.5 4.5a4.5 4.5 0 0 1-6.364-6.364l1.757-1.757m13.35-.622 1.757-1.757a4.5 4.5 0 0 0-6.364-6.364l-4.5 4.5a4.5 4.5 0 0 0 1.242 7.244" />
            </svg>

            @if(showLabel()) {

               
                <p class="font-bold text-xs text-black ml-2 ">
                        <span>
                            {{translation.getText('copy_link', 'copy_link_text')}}
                        </span>
                </p>
     
                <button class="cursor-pointer ml-auto" (click)="forceClose(); $event.stopPropagation()">
                    <span>
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="size-3.5">
                            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                        </svg>
                    </span>
                </button>

            }

          
    </app-button>

    @if(showUrlPanel()) {
        <div class="absolute right-0 top-full mt-2 z-50 flex items-center gap-1.5 bg-black rounded-lg shadow-lg border border-semiblack p-1.5 w-max">
            <input
                #urlInput
                type="text"
                readonly
                [value]="generatedUrl()"
                class="text-xs text-gray-100 bg-black border border-gray-500 rounded px-2 py-1 outline-none w-[260px] select-all"
                (focus)="urlInput.select()"
            />
            <button
                class="cursor-pointer flex items-center justify-center rounded p-1 hover:bg-gray-100 transition-colors"
                [class]="{ 'text-gray-300': copied(), 'text-gray-500': !copied() }"
                (click)="copyFromInput(); $event.stopPropagation()"
            >
                @if(copied()) {
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="size-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="m4.5 12.75 6 6 9-13.5" />
                    </svg>
                } @else {
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.8" stroke="currentColor" class="size-4">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M15.666 3.888A2.25 2.25 0 0 0 13.5 2.25h-3c-1.03 0-1.9.693-2.166 1.638m7.332 0c.055.194.084.4.084.612v0a.75.75 0 0 1-.75.75H9.75a.75.75 0 0 1-.75-.75v0c0-.212.03-.418.084-.612m7.332 0c.646.049 1.288.11 1.927.184 1.1.128 1.907 1.077 1.907 2.185V19.5a2.25 2.25 0 0 1-2.25 2.25H6.75A2.25 2.25 0 0 1 4.5 19.5V6.257c0-1.108.806-2.057 1.907-2.185a48.208 48.208 0 0 1 1.927-.184" />
                    </svg>
                }
            </button>
            <button
                class="cursor-pointer flex items-center justify-center rounded p-1 text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors"
                (click)="closeUrlPanel(); $event.stopPropagation()"
            >
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" class="size-3.5">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18 18 6M6 6l12 12" />
                </svg>
            </button>
        </div>
    }

</div>
